module.exports = __webpack_public_path__ + "static/img/wdys1-3.1b31d0a.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdys1-3.png
// module id = 889
// module chunks = 0